import React, { useCallback, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { Box, makeStyles } from "@material-ui/core";
import W21099SummaryDialog from "./W21099SummaryDialog";
import CustomCardHeader from "../../CustomCardHeader";
import {
  REPORT_ITEM_TYPE,
  REPORT_ITEM_SUB_TYPE
} from "../../../../../constants";
import Button from "components/CustomButtons/Button";
import { Edit } from "@material-ui/icons";

const useStyles = makeStyles({
  actions: {
    margin: "0 0 0 5px",
    padding: 5,
    "& svg": {
      margin: 0
    }
  }
});
const W21099Summary = ({
  reportID,
  chapterFinancial,
  updateReportW2,
  onRefetch,
  onHelp,
  isEditable,
  chapterID,
  year,
  initialReportItems,
  onRedirect
}) => {
  const classes = useStyles();

  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const onSaveEditDialog = useCallback(
    async ({ countw2, count1099 }) => {
      if (reportID === "add") {
        const _reportID = await initialReportItems({
          chapterID,
          year,
          countw2: +countw2,
          count1099: +count1099
        });
        onRedirect(_reportID);
      } else {
        await updateReportW2({
          id: +reportID,
          countw2: +countw2,
          count1099: +count1099
        });
      }

      onRefetch();
      setEditDialogOpen(false);
    },
    [reportID]
  );
  return (
    <Box mb={3}>
      <CustomCardHeader
        label={"W-2 and 1099 Summary"}
        onHelp={() =>
          onHelp(REPORT_ITEM_TYPE.EXPENSE, REPORT_ITEM_SUB_TYPE.ADVERTISING)
        }
        extraContent={
          isEditable && (
            <Button
              simple
              color="primary"
              className={classes.actions}
              onClick={() => setEditDialogOpen(true)}
            >
              <Edit />
            </Button>
          )
        }
      />
      <Box display="flex" justifyContent="space-between" px={1} py={0.5}>
        <Typography>Number of 1099s issued:</Typography>
        <Typography>
          {(chapterFinancial &&
            chapterFinancial.report &&
            chapterFinancial.report.count1099) ||
            0}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" px={1} py={0.5}>
        <Typography>Number of W2s issued:</Typography>
        <Typography>
          {(chapterFinancial &&
            chapterFinancial.report &&
            chapterFinancial.report.countW2) ||
            0}
        </Typography>
      </Box>

      <W21099SummaryDialog
        open={editDialogOpen}
        data={{
          count1099:
            (chapterFinancial &&
              chapterFinancial.report &&
              chapterFinancial.report.count1099) ||
            0,
          countw2:
            (chapterFinancial &&
              chapterFinancial.report &&
              chapterFinancial.report.countW2) ||
            0
        }}
        onClose={() => setEditDialogOpen(false)}
        onSave={onSaveEditDialog}
      />
    </Box>
  );
};

export default W21099Summary;
